import { useEffect, useState } from "react";
import { Search, User, Banknote, Loader2, X } from "lucide-react";
import api from "@/lib/api";

export function AdminSearch({ onUser, onDeposit }) {
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (q.trim().length < 2) { setRes(null); return; }
    setLoading(true);
    const t = setTimeout(() => {
      api.get("/admin/search", { params: { q } }).then(({ data }) => setRes(data)).catch(() => setRes(null)).finally(() => setLoading(false));
    }, 300);
    return () => clearTimeout(t);
  }, [q]);

  const pick = (fn) => { fn(); setQ(""); setRes(null); };
  const empty = res && res.users.length === 0 && res.deposits.length === 0;

  return (
    <div className="relative mb-3" data-testid="admin-search">
      <div className="flex items-center gap-2 px-3 py-2.5 rounded-xl bg-pazer-bg border border-pazer-line focus-within:border-pazer-red transition-colors">
        <Search className="h-4 w-4 text-white/40 shrink-0" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Player, mobile, deposit ID…"
          data-testid="admin-search-input" className="bg-transparent outline-none text-sm w-full placeholder:text-white/30" />
        {loading ? <Loader2 className="h-4 w-4 animate-spin text-pazer-red" />
          : q && <button onClick={() => setQ("")} data-testid="admin-search-clear"><X className="h-4 w-4 text-white/40 hover:text-white" /></button>}
      </div>
      {res && (
        <div className="absolute left-0 right-0 lg:right-auto lg:w-80 mt-2 z-50 rounded-xl bg-pazer-deep border border-pazer-line shadow-2xl shadow-black/50 max-h-96 overflow-y-auto p-2" data-testid="admin-search-results">
          {empty && <p className="text-xs text-white/40 text-center py-4" data-testid="admin-search-empty">No matches</p>}
          {res.users.length > 0 && <p className="px-2 pt-1 pb-1 text-[10px] uppercase tracking-widest text-white/40">Players</p>}
          {res.users.map((u) => (
            <button key={u.id} onClick={() => pick(() => onUser(u.id))} data-testid={`search-user-${u.id}`}
              className="w-full flex items-center gap-2 px-2 py-2 rounded-lg hover:bg-white/5 text-left transition-colors">
              <User className="h-4 w-4 text-pazer-red shrink-0" />
              <span className="min-w-0"><span className="block text-sm font-semibold truncate">{u.display_name || u.username}</span>
                <span className="block text-[11px] text-white/40">@{u.username} · {u.mobile}</span></span>
            </button>
          ))}
          {res.deposits.length > 0 && <p className="px-2 pt-2 pb-1 text-[10px] uppercase tracking-widest text-white/40">Deposits</p>}
          {res.deposits.map((d) => (
            <button key={d.ref} onClick={() => pick(() => onDeposit(d))} data-testid={`search-deposit-${d.ref}`}
              className="w-full flex items-center gap-2 px-2 py-2 rounded-lg hover:bg-white/5 text-left transition-colors">
              <Banknote className="h-4 w-4 text-green-400 shrink-0" />
              <span className="min-w-0 flex-1"><span className="block text-sm font-mono-pz truncate">{d.ref}</span>
                <span className="block text-[11px] text-white/40">{d.username} · {d.amount} · {d.kind}</span></span>
              <span className="text-[10px] uppercase px-1.5 py-0.5 rounded bg-white/10 text-white/60">{d.status}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
